import { createSelector } from 'reselect';

const selectListReducer = state => state.lists;
const getKey = (_, key) => key;

export const selectList = list => state => selectListReducer(state)[list];
export const selectListFromStore = createSelector(
  selectListReducer,
  getKey,
  (lists, list_key) => lists[list_key]
);
export const selectListOptionsFromStore = createSelector(
  selectListFromStore,
  list => list?.options
);

const selectListDefaults = createSelector(selectListReducer, lists => lists?._defaults);
export const selectListDefaultOptions = createSelector(
  selectListDefaults,
  getKey,
  (defaults, list_key) => defaults?.[list_key]?.options || []
);
export const selectListDefaultLastFetchedAt = createSelector(
  selectListDefaults,
  getKey,
  (defaults, list_key) => defaults?.[list_key]?.lastFetchedAt || null
);

export const selectUnitsByType = type => state =>
  state.lists.units.options.filter(unit => unit.type === type);

export const selectUnits =
  (labels = []) =>
  state =>
    labels
      .map(label => {
        const unit = state.lists.units.options.find(unit => unit.label === label);
        return unit || null;
      })
      .filter(unit => unit !== null);

export const selectUnitById = id => state => state.lists.units.options.find(unit => unit.id === id);

export const hasFetchedList = list => state => {
  const listState = selectList(list)(state);
  return listState.options.length > 0 || listState.options.isFetching;
};

export const selectBeaconPostSuggestions = createSelector(selectListOptionsFromStore, options =>
  (options || [])?.map(o => ({ label: o, value: o }))
);

export const selectCorePageUrl = (state, list, label, prefix) => {
  const suggestions = selectBeaconPostSuggestions(state, list);

  return suggestions?.find(suggestion => {
    switch (suggestion.value) {
      case 'purchasing-budget':
        return 'budget';
      default:
        return suggestion.value.includes(label) && suggestion.value.startsWith(prefix);
    }
  })?.value;
};
